import {
  ImagePreview
} from 'vant'

function getYMD (time) {
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  return year + '-' + singleFormat(month) + '-' + singleFormat(date)
}

function getMD (time) {
  let month = time.getMonth() + 1
  let date = time.getDate()
  return singleFormat(month) + '-' + singleFormat(date)
}

function getHMS (time) {
  let hours = time.getHours()
  let minutes = time.getMinutes()
  let seconds = time.getSeconds()
  return singleFormat(hours) + ':' + singleFormat(minutes) + ':' + singleFormat(seconds)
}

function getTimeZone (time) {
  let GTM_8 = 480 // -480
  let date = new Date(time)
  let subMin = date.getTimezoneOffset() + GTM_8
  date.setMinutes(date.getMinutes() + subMin)
  return date
}
// 获取时间年月日 时分秒
export const timeFormat = (time, type) => {
  let date = getTimeZone(time)
  if (!type) return getYMD(date) + ' ' + getHMS(date)
  switch (type) {
    case 'HMS':
      return getHMS(date)
    case 'YMD':
      return getYMD(date)
    case 'MD':
      return getMD(date)
  }
}

export const openPreview = (img) => {
  ImagePreview({
    images: img,
    showIndex: false,
    loop: true,
    closeable: true,
    startPosition: 0
  })
}

export const base64ToFormData = (base64, filename) => {
  var blob = dataURLtoBlob(base64)
  var formData = new FormData()
  formData.append('file', blob, filename) // 'file' 是你后端期望的字段名
  return formData
}

function dataURLtoBlob (dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new Blob([u8arr], {
    type: mime
  })
}



// WEBPACK FOOTER //
// ./src/utils/index.js